import AOS from 'aos';
import "aos/dist/aos.js";

import "../scss/page.scss";

import "../scss/web-mobile-landing.scss";

import "./scripts/dm-marketing/navbar.js";
import "./scripts/matchHeight/web-mobile-landing.js";
import "./scripts/slick/web-mobile-landing.js";
import "./scripts/web-mobile-landing/techs.js";
import "./scripts/web-mobile-landing/areas.js";
import "./scripts/web-mobile-landing/benefit.js";

AOS.init();

import * as bootstrap from 'bootstrap';
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))